import { render, staticRenderFns } from "./semtel.vue?vue&type=template&id=2675df97&"
import script from "./semtel.vue?vue&type=script&lang=js&"
export * from "./semtel.vue?vue&type=script&lang=js&"
import style0 from "./semtel.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports